<template>
  <!--弹框2 英文 开始-->
  <div class="dia-info">
    <el-dialog :visible.sync="frameNoticeDialog" top="35vh" :close-on-click-modal="showClo" :close-on-press-escape="showClo" :width="frameWidth" :show-close="showClo" center class="textcenter-en">
      <div style="width:100%;text-align: center;">
        <div><img src="/static/img/frame/notice.png" class="frame-big-img"></div>
        <div class="frame-text-hotel-sold wordBreak">
          {{$t('networkInterruptRetry')}}
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="booknow_button" style="float: none; width: auto;" @click="goFinalStep">{{$t('goFinalStep')}}</el-button>
      </span>
    </el-dialog>
  </div>
  <!--弹框2 英文 结束-->
  <!--引入方式-->
  <!-- <frameNotice :frameNoticeDialog="frameNoticeDialog"></frameNotice> -->
</template>

<script>
import { getCityId } from '@/request/hotel.js'
export default {
  name: 'frameNotice',
  props: ['frameNoticeDialog'],
  data () {
    return {
      frameWidth: '450px',
      showClo: false,
      city: {},
      adult: 2,
      child: 0,
      room: 1,
      startdate: '',
      enddate: '',
      hotelid: ''
    }
  },
  created () {
    var query = this.$route.query
    if (JSON.stringify(query) !== '{}') {
      this.adult = parseInt(this.$route.query.adult)
      this.child = parseInt(this.$route.query.child)
      this.room = parseInt(this.$route.query.room)

      this.startdate = this.$route.query.start_date
      this.enddate = this.$route.query.end_date
    } else {
      var params = this.$route.params
      var searchData = localStorage.getItem('searchData')
      if (JSON.stringify(params) === '{}' && searchData !== '{}' && searchData !== null) {
        params = JSON.parse(searchData)
      }
      if (JSON.stringify(params) !== '{}' || (searchData !== '{}' && searchData !== null)) {
        this.adult = parseInt(params.adult)
        this.child = parseInt(params.child)
        this.room = parseInt(params.room)
        this.startdate = params.start_date
        this.enddate = params.end_date
      }
    }

    // 获取城市ID
    this.getCityIdFun()
  },
  mounted () {
    if (document.body.clientWidth < 1001) {
      this.frameWidth = '95%'
    } else {
      this.frameWidth = '450px'
    }
  },
  methods: {
    // 获取城市ID
    getCityIdFun: function () {
      var query = this.$route.query
      if (JSON.stringify(query) !== '{}' && query.hotelid !== undefined) {
        this.hotelid = this.$route.query.hotelid
      } else {
        var params = this.$route.params
        var orderData = localStorage.getItem('orderData')
        if (JSON.stringify(params) === '{}' && orderData !== '{}') {
          params = JSON.parse(orderData)
        }
        this.hotelid = params.hotelid
      }

      var time = parseInt(new Date().getTime() / 1000)
      var sessionid = this.common.sessionidGet(this)

      var DataJson = {'hotelid': this.hotelid, 'operation': 'getCityId', 'time': time, 'sessionid': sessionid}
      var Data = this.common.encryptionData(DataJson, this)
      getCityId(Data).then(res => {
        this.city = res.data.hotelCity
      })
    },
    // 城市跳转
    goFinalStep: function () {
      var paysubmitInfo = {'click': 1}
      this.$emit('frameNoticeFun', paysubmitInfo)
    }
  }
}
</script>

<style scoped>
.textcenter-en{text-align: center;}
.frame-big-img{width:100px; height:100px;cursor: pointer;}
.frame-text-hotel-sold{height:20px; font-size: 16px;color: #4F4C4C;text-align: center; margin-top: 10px;}
.dia-info /deep/ .el-dialog__header{padding: 0;}
</style>



// WEBPACK FOOTER //
// src/components/public/frameNotice.vue